/**
 *
 * Atualiza o campo "nome" do estado do pagamento com base no valor digitado pelo usuário.
 *
 * @param {Event} event - Evento disparado pelo input que contém o novo valor.
 * @param {Function} setSelectedPayment - Função que atualiza o estado do pagamento.
 */
export function changeInputName(event, setSelectedPayment) {
    const value = event.target.value;

    setSelectedPayment((prevState) => ({
        ...prevState,
        nome: value,
    }));
}